"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var renderCaption = function renderCaption(caption) {
  if (caption) {
    return React.createElement(
      "p",
      { className: "caption" },
      caption
    );
  }

  return null;
};

exports.default = renderCaption;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/utils/renderCaption.js
// module id = 1282
// module chunks = 0